export default __webpack_public_path__ + "static/media/Expert@2x-min.f3527e26.png";